/* Nutritia signup popup (sections/signup-popup.liquid).

   Signup mode: on phones a small teaser bar appears after the visitor scrolls
   (or a fallback delay) and only a tap opens the popup; on desktop the popup
   opens on exit-intent (or a fallback delay). Offer mode keeps the plain
   delay. Nothing shows if the visitor closed it or signed up within the
   suppression window. Uses a native <dialog> with
   showModal(): Escape closes it, focus stays inside, the page behind is inert.
   Focus returns to whatever was focused before it opened.

   The form posts natively (not over fetch): Shopify protects customer forms
   with a CAPTCHA token that is only attached on a real submit, so a fetch post
   is rejected. The page comes back with the result rendered server-side
   (success or Shopify's error), and the popup reopens on it. */
(function () {
  if (customElements.get('nutritia-signup')) return;

  var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function store(key, value) {
    try {
      if (value === undefined) return localStorage.getItem(key);
      localStorage.setItem(key, value);
    } catch (e) { /* private mode: the popup simply shows again next visit */ }
    return null;
  }

  class NutritiaSignup extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('[data-nsu-dialog]');
      if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
      this.key = this.dataset.key || 'nutritia-signup-1';
      this.days = Number(this.dataset.suppressDays || 7);

      this.bindClose();
      this.bindForm();
      this.bindCopy();

      // Back from a submit: show the result (the code, or the error) right away.
      if (this.querySelector('[data-nsu-done]')) {
        this.suppress();
        this.open();
        return;
      }
      if (this.querySelector('[data-nsu-error]:not([hidden])')) {
        this.open();
        return;
      }

      if (this.suppressed()) return;
      var self = this;
      // Never stack on top of another open dialog (cart, lightbox, quiz...).
      function openIfFree() {
        if (document.querySelector('dialog[open]')) return false;
        self.open();
        return true;
      }

      if (this.dataset.mode === 'signup') {
        this.teaser = this.querySelector('[data-nsu-teaser]');
        var phone = window.matchMedia('(max-width: 749px)').matches;
        // Phones: a small bar the visitor taps, never a full-screen popup on
        // arrival (Google's intrusive-interstitial guideline).
        if (phone && this.teaser && this.dataset.teaser === 'true') { this.armTeaser(); return; }
        // Desktop: open when the pointer leaves through the top of the window
        // (heading for the tabs or address bar), with a time fallback.
        if (!phone && this.dataset.exitIntent === 'true') { this.armExitIntent(openIfFree); return; }
      }

      this.timer = setTimeout(openIfFree, Number(this.dataset.delay || 8000));
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
      if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
      if (this.onLeave) document.removeEventListener('mouseout', this.onLeave);
    }

    armTeaser() {
      var self = this;
      var threshold = Number(this.dataset.scroll || 40) / 100;
      var shown = false;
      function show() {
        if (shown) return;
        // Wait while another dialog (cart, menu) is open; try again on the next scroll.
        if (document.querySelector('dialog[open]')) return;
        shown = true;
        clearTimeout(self.timer);
        window.removeEventListener('scroll', self.onScroll);
        self.teaser.hidden = false;
        requestAnimationFrame(function () { self.teaser.classList.add('is-visible'); });
      }
      this.onScroll = function () {
        var max = document.documentElement.scrollHeight - window.innerHeight;
        if (max > 0 && window.scrollY / max >= threshold) show();
      };
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.timer = setTimeout(show, Number(this.dataset.teaserDelay || 20000));

      this.teaser.querySelector('[data-nsu-claim]').addEventListener('click', function () {
        self.hideTeaser();
        self.open();
      });
      this.teaser.querySelector('[data-nsu-teaser-close]').addEventListener('click', function () {
        self.hideTeaser();
        self.suppress();
      });
    }

    hideTeaser() {
      if (!this.teaser) return;
      this.teaser.classList.remove('is-visible');
      this.teaser.hidden = true;
    }

    armExitIntent(openIfFree) {
      var self = this;
      var done = false;
      function fire() {
        if (done) return;
        if (!openIfFree()) return;
        done = true;
        clearTimeout(self.timer);
        document.removeEventListener('mouseout', self.onLeave);
      }
      this.onLeave = function (e) {
        if (!e.relatedTarget && e.clientY <= 0) fire();
      };
      // Give the visitor a moment on the page before exit-intent can fire.
      setTimeout(function () { document.addEventListener('mouseout', self.onLeave); }, 3000);
      this.timer = setTimeout(fire, Number(this.dataset.desktopDelay || 30000));
    }

    suppressed() {
      var until = Number(store(this.key));
      return Boolean(until) && Date.now() < until;
    }

    suppress() { store(this.key, String(Date.now() + this.days * 86400000)); }

    open() {
      this.lastFocus = document.activeElement;
      this.dialog.showModal();
      var target = this.querySelector('[data-nsu-copy]') ||
        (this.querySelector('[aria-invalid="true"]')) ||
        this.querySelector('.nsu__input') ||
        this.querySelector('[data-nsu-close]');
      if (target) target.focus({ preventScroll: true });
    }

    close() {
      if (this.dialog.open) this.dialog.close();
    }

    bindClose() {
      var self = this;
      this.querySelectorAll('[data-nsu-close]').forEach(function (btn) {
        btn.addEventListener('click', function () { self.close(); });
      });
      // Keep Tab inside the popup. A modal <dialog> blocks the page behind it,
      // but still lets focus leave to the browser's own toolbar.
      this.dialog.addEventListener('keydown', function (e) {
        if (e.key !== 'Tab') return;
        var items = Array.prototype.filter.call(
          self.dialog.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled]), [tabindex]:not([tabindex="-1"])'),
          function (el) { return el.offsetParent !== null || el === document.activeElement; }
        );
        if (!items.length) return;
        var first = items[0], last = items[items.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      });
      // A click on the backdrop (outside the panel) closes it.
      this.dialog.addEventListener('click', function (e) {
        if (e.target === self.dialog) self.close();
      });
      // Every close path (button, Escape, backdrop) suppresses and restores focus.
      this.dialog.addEventListener('close', function () {
        if (self.submitting && self.dialog.open) return; // modal -> non-modal swap on submit
        self.suppress();
        if (self.lastFocus && typeof self.lastFocus.focus === 'function' && document.contains(self.lastFocus)) {
          self.lastFocus.focus({ preventScroll: true });
        }
      });
    }

    bindForm() {
      var self = this;
      var form = this.querySelector('[data-nsu-form]');
      if (!form) return;
      var input = form.querySelector('input[type="email"]');
      var error = form.querySelector('[data-nsu-error]');
      var submit = form.querySelector('[data-nsu-submit]');
      // Shopify appends #contact_form to the action; drop it so the page
      // does not jump when it comes back.
      if (form.action.indexOf('#') !== -1) form.action = form.action.split('#')[0];

      function showError(message) {
        error.textContent = message;
        error.hidden = false;
        input.setAttribute('aria-invalid', 'true');
        input.focus();
      }
      if (input) {
        input.addEventListener('input', function () {
          if (input.getAttribute('aria-invalid') === 'true' && EMAIL.test(input.value.trim())) {
            input.removeAttribute('aria-invalid');
            error.hidden = true;
          }
        });
      }
      form.addEventListener('submit', function (e) {
        var value = input ? input.value.trim() : '';
        if (!value) { e.preventDefault(); showError(window.Nutritia.t('email_required', 'Please enter your email address.')); return; }
        if (!EMAIL.test(value)) { e.preventDefault(); showError(window.Nutritia.t('email_invalid', 'Please enter a valid email address, like name@example.com.')); return; }
        input.value = value;
        // Shopify may answer the submit with a visible CAPTCHA check. A modal
        // dialog makes everything outside it inert, which would trap that check
        // behind the popup. Switch to a non-modal dialog (same look, same dim
        // background) so the check can appear on top and be answered.
        if (self.dialog.open && self.dialog.matches(':modal')) {
          self.submitting = true;
          self.dialog.close();
          self.dialog.show();
          self.dialog.classList.add('is-submitting');
        }
        if (submit) {
          submit.disabled = true;
          submit.setAttribute('aria-busy', 'true');
          submit.classList.add('is-loading');
          var label = submit.querySelector('[data-nsu-label]');
          if (label) label.textContent = window.Nutritia.t('signing_up', 'Signing you up…');
        }
      });
      // If the browser restores this page from the back/forward cache, re-enable the button.
      window.addEventListener('pageshow', function () {
        if (!submit) return;
        submit.disabled = false;
        submit.removeAttribute('aria-busy');
        submit.classList.remove('is-loading');
      });
    }

    bindCopy() {
      var btn = this.querySelector('[data-nsu-copy]');
      if (!btn) return;
      var status = this.querySelector('[data-nsu-status]');
      var codeEl = this.querySelector('[data-nsu-code]');
      btn.addEventListener('click', function () {
        var code = btn.getAttribute('data-nsu-copy');
        function done() {
          btn.textContent = window.Nutritia.t('copied', 'Copied');
          btn.classList.add('is-copied');
          if (status) status.textContent = window.Nutritia.t('code_copied', 'Code {code} copied to your clipboard.', {code: code});
          setTimeout(function () { btn.textContent = window.Nutritia.t('copy_code', 'Copy code'); btn.classList.remove('is-copied'); }, 2400);
        }
        function fallback() {
          try {
            var range = document.createRange();
            range.selectNodeContents(codeEl);
            var sel = window.getSelection(); sel.removeAllRanges(); sel.addRange(range);
            if (document.execCommand && document.execCommand('copy')) { done(); return; }
          } catch (e) { /* ignore */ }
          if (status) status.textContent = window.Nutritia.t('code_select', 'Select the code and copy it: {code}', {code: code});
        }
        if (navigator.clipboard && window.isSecureContext) {
          navigator.clipboard.writeText(code).then(done, fallback);
        } else {
          fallback();
        }
      });
    }
  }

  customElements.define('nutritia-signup', NutritiaSignup);
})();
